import { Component, inject, input } from '@angular/core';
import { IconComponent } from '@app2/shared/components/icon/icon.component';
import { Store } from '@ngrx/store';
import { sessionSelectors } from '@store/session';
import { userSelectors } from '@store/user';
import { AuthComponent } from '@app2/features/auth/auth.component';
import { DialogService } from 'primeng/dynamicdialog';
import { SubscribeModalComponent } from '@app2/shared/components/subscribe-modal/subscribe-modal.component';
import { AnalystService } from '@app/services/analyst/analyst.service';
import { AnalyticsEventsEnum } from '@core/models/analytics.model';

@Component({
  selector: 'sens-subscribe-banner',
  imports: [
    IconComponent,
  ],
  templateUrl: './subscribe-banner.component.html',
})
export class SubscribeBannerComponent {

  public type = input<string>('aside');

  private store = inject(Store);

  private dialogService = inject(DialogService);

  private analystService = inject(AnalystService);

  public isSetUser = this.store.selectSignal(sessionSelectors.selectIsSetUser);

  public user = this.store.selectSignal(userSelectors.selectUserData);

  onSubscribe() {
    this.analystService.logEvent(AnalyticsEventsEnum.SubscriptionsBannerTap, {
      type: this.type(),
    }).then();
    if (!this.isSetUser()) {
      this.dialogService.open(AuthComponent, {
        header: undefined,
        showHeader: false,
        modal: true,
        dismissableMask: true,
        transitionOptions: '.3s ease-in-out',
      });
    } else {
      this.dialogService.open(SubscribeModalComponent, {
        header: undefined,
        showHeader: false,
        modal: true,
        dismissableMask: true,
        transitionOptions: '.3s ease-in-out',
      });
    }
  }
}
